// extracted by mini-css-extract-plugin
export default {"permissions_table":"Permissions_permissions_table__1w422","checkbox_wrapper":"Permissions_checkbox_wrapper__3Swiq"};